// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__2AUvE","withIcon":"styles_withIcon__Wmt_8","arrowRight":"styles_arrowRight__2Fgs7"};